"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const edge_device_management_typescript_client_1 = require("@amzn/edge-device-management-typescript-client");
const apis_1 = require("../../../service/apis");
const base_layout_1 = require("../../common/base_layout");
const bread_crumbs_1 = require("../../common/bread_crumbs");
const CONSTANTS = __importStar(require("../../../common/constants"));
const notification_1 = require("../../common/notification");
const provision_detail_summary_table_1 = require("../../common/provision_detail_summary_table");
const time_range_selector_1 = require("../../common/time_range_selector");
const process_helpers_1 = require("../../../common/process_helpers");
const constants_1 = require("../../../common/constants");
const functions_1 = require("../../../common/functions");
function Provisions() {
    // Cast RelativeOption type to RelativeValue type
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const [bundleLoaded, setBundleLoaded] = react_1.default.useState(false);
    const [timeRangeValue, setTimeRangeValue] = react_1.default.useState(time_range_selector_1.RelativeOptionThirtyMinutes);
    const [refreshData, setRefreshData] = react_1.default.useState(false);
    const [provisionDetailSummaries, setProvisionDetailSummaries] = react_1.default.useState();
    const [notification, setNotification] = react_1.default.useState([]);
    const process = (0, process_helpers_1.useProcess)();
    react_1.default.useEffect(() => {
        if (localeBundle !== undefined) {
            setBundleLoaded(true);
        }
    });
    react_1.default.useEffect(() => {
        if (localeBundle != undefined) {
            const userName = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_USERNAME);
            if (userName == null) {
                console.log('Failed to get username for listing provisioned devices');
            }
            const timeRange = timeRangeValue
                ? (0, time_range_selector_1.convertTimeRangeValueToDate)(timeRangeValue)
                : (0, time_range_selector_1.convertTimeRangeValueToDate)(time_range_selector_1.RelativeOptionThirtyMinutes);
            console.log(`Fetching devices provisioned from [${timeRange.start.toUTCString()}] to [${timeRange.end.toUTCString()}].`);
            setProvisionDetailSummaries(undefined);
            (0, apis_1.getApis)()
                .listProvisionDetails({
                processId: process.selectedProcess,
                queryStartTime: timeRange.start,
                queryEndTime: timeRange.end,
                showDuplicatedRecords: false,
                provisionDetailsFilters: [
                    {
                        key: 'Username',
                        value: CONSTANTS.UNKNOWN_USERNAME,
                        operator: edge_device_management_typescript_client_1.DynamoDBConditionOperator.NOT_EQUAL,
                    },
                ],
            })
                .then((response) => {
                setProvisionDetailSummaries(response);
                setNotification([]);
            })
                .catch((error) => {
                setProvisionDetailSummaries(undefined);
                const errorHeader = error.response != null && (error.response.status == 403 || error.response.status == 401)
                    ? localeBundle.getMessage('unauthorized-user')
                    : localeBundle.getMessage('something-wrong');
                let errorContent;
                if (error.response == null) {
                    errorContent = localeBundle.getMessage('refresh-page');
                }
                else {
                    errorContent =
                        error.response.status == 403 || error.response.status == 401
                            ? `${localeBundle.formatMessage((0, functions_1.getErrorMessageLocaleBundleKeyFromOperationName)(constants_1.EDM_API_TO_DEVICE_GROUP_OPERATION_MAP.get(constants_1.EDM_LIST_PROVISION_DETAILS_API_NAME)), {
                                wikiLink: CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK,
                            })} Error: ${error.response.data.message}`
                            : `Error: ${error.response.data.message} ${localeBundle.getMessage('refresh-page')}`;
                }
                setNotification([
                    {
                        header: errorHeader,
                        type: 'error',
                        content: errorContent,
                        dismissible: true,
                        dismissLabel: 'Dismiss message',
                        onDismiss: () => setNotification([]),
                    },
                ]);
                if (error.response) {
                    console.log(`Failed to list provisioned devices due to ${error.response.data.message}`);
                }
                else {
                    console.log(`Failed to list provisioned devices due to ${JSON.stringify(error)}`);
                }
            });
        }
    }, [refreshData, bundleLoaded, process.selectedProcess]);
    const onRefreshClick = () => {
        setRefreshData(!refreshData);
    };
    const onTimeRangeValueChangeFunction = (changeDetail) => {
        if (!changeDetail.value) {
            setTimeRangeValue(time_range_selector_1.RelativeOptionThirtyMinutes);
        }
        else {
            setTimeRangeValue(changeDetail.value);
        }
        setRefreshData(!refreshData);
    };
    const timeRangeSelectorProps = {
        timeRangeValue: timeRangeValue,
        onTimeRangeValueChange: onTimeRangeValueChangeFunction,
    };
    return ((0, jsx_runtime_1.jsx)(base_layout_1.BaseLayout, { breadcrumbs: (0, jsx_runtime_1.jsx)(bread_crumbs_1.Breadcrumbs, { items: [
                {
                    text: localeBundle === undefined
                        ? 'Provision status'
                        : localeBundle.getMessage('provision-status'),
                    href: '#/provision/provisions',
                },
            ] }), contentHeader: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Header, { variant: "h1", actions: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { iconName: "refresh", variant: "normal", onClick: () => onRefreshClick(), children: localeBundle === undefined ? 'Refresh' : localeBundle.getMessage('refresh') }) }), notifications: (0, jsx_runtime_1.jsx)(notification_1.Notification, { items: notification }), content: (0, jsx_runtime_1.jsx)(provision_detail_summary_table_1.ProvisionDetailsSummaryTable, { isManagedEdgeCompute: false, provisionDetailSummaries: provisionDetailSummaries, contentType: 'provision', timeRangeSelectorProps: timeRangeSelectorProps }), contentType: "default" }));
}
exports.default = Provisions;
